import { render, staticRenderFns } from "./Contatos.vue?vue&type=template&id=bf7b3f10"
import script from "./Contatos.vue?vue&type=script&lang=js"
export * from "./Contatos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports